import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import CustomButton from '../../../../../../components/MUIComponents/CustomButton';
import { ButtonTypeEnum } from '../../../../../../enums/button-type-enum';
import BoxIcon from '../../../../../../components/Icons/BoxIcon';

interface EmptyWorkExperienceProps {
  isOwnPage: boolean;
  handleAddWorkExperience: () => void;
  sx?: SxProps;
}

const EmptyWorkExperience = ({
  isOwnPage,
  handleAddWorkExperience,
  sx,
}: EmptyWorkExperienceProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1.375rem',

        ...sx,
      }}
    >
      <BoxIcon />

      <Typography variant="h3" textAlign="center">
        No information about work experience
      </Typography>

      {isOwnPage && (
        <CustomButton
          variantType={ButtonTypeEnum.SECONDARY}
          onClick={handleAddWorkExperience}
          sx={{
            width: { xs: '100%', md: 'max-content' },
            padding: '19px 41px',
          }}
        >
          add work experience
        </CustomButton>
      )}
    </Box>
  );
};

export default EmptyWorkExperience;
